import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';

class PACaricaFatturaSummaryController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        '$http',
        'configuration',
        'store',
        'jwtHelper',
        'ArchiSmallServices',
        '$uibModal'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private $http: ng.IHttpService,
        private configuration: any,
        private store: ng.a0.storage.IStoreService,
        private jwtHelper: any,
        private ArchiSmallServices: ArchiSmallServices,
        private $uibModal: ng.ui.bootstrap.IModalService
    ) {
        $scope.pageHeader = 'Carica Fattura';
        $scope.pageSubHeader = 'Riepilogo';

        let result = store.get('FatturazionepaCaricaFattura-Result');
        if (result === undefined) {
            $state.go('home.home-index');
        }
        result.messageId = Number(result.messageId);
        result.messageStatus = Number(result.messageStatus);
        $scope.result = result;
        $scope.next = () => {
            store.remove('FatturazionepaCaricaFattura-Result');
            $state.go('home.fatturazione-pa');
        };
    }

}

export const PACaricaFatturaSummaryComponent: ng.IComponentOptions = {
    template: require('./pa-carica-fattura-summary.html'),
    controller: PACaricaFatturaSummaryController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/pa-carica-fattura-summary/pa-carica-fattura-summary.ts